import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CmsTopicRestorationRequestDto, CmsTopicSubscriptionPublicRequest, DeviceTokenRefreshDto, TopicSubscriptionContainerModel } from '../../../../../../models';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../../shared';


@Injectable({ providedIn: 'root' })

export class TopicSubscriptionService extends BaseApiTemplateService<TopicSubscriptionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topic-subscriptions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topic-subscriptions';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topic-subscriptions/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

  getTopicSubscriptionsForSubject(pagination: Pagination, apiVisa: ApiVisa, deviceToken?: string) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;

    const path = this.endpoint_path + '/login-ep/user-subscriptions';

    const httpOptions: { headers: HttpHeaders } = {
      ...this.getHttpHeader(apiVisa),
    };

    const UrlByCriteria = domain + path + (deviceToken == null ? '?' : `?deviceToken=${deviceToken}`) + pagination.getQueryKeyValues();

    return this.httpClient.get<PagingResponseModel<TopicSubscriptionContainerModel>>(
      UrlByCriteria,
      httpOptions
    );
  }

  updateDeviceTokenByMemberGuid(cmsTopicRestorationRequestDto: CmsTopicRestorationRequestDto, apiVisa: ApiVisa) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;
      
    const path = domain + this.endpoint_path + '/member-device-restore/public-ep';

    const httpOptions: { headers: HttpHeaders } = {
      ...this.getHttpHeader(apiVisa),
    };

    return this.httpClient.put<BasicApiResponseModel<any>>(
      path,
      cmsTopicRestorationRequestDto,
      httpOptions
    );
  }

  refreshDeviceToken(deviceTokenRefreshDto: DeviceTokenRefreshDto, apiVisa: ApiVisa) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;

    const path = domain + this.endpoint_path + '/refresh-device-token/public-ep';

    const httpOptions: { headers: HttpHeaders } = {
      ...this.getHttpHeader(apiVisa),
    };

    return this.httpClient.put<BasicApiResponseModel<any>>(
      path,
      deviceTokenRefreshDto,
      httpOptions
    );
  }


  postTopicSubscriptionPublic(dtoObject: CmsTopicSubscriptionPublicRequest, websiteCode: string, apiVisa: ApiVisa) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;

    const path = domain + this.endpoint_path + '/public-ep';

    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code,
        websiteCode: websiteCode
      })
    };

    return this.httpClient.post<ApiResponseModel<TopicSubscriptionContainerModel>>(
      path,
      dtoObject,
      httpOptions
    );
  }

  postTopicUnubscribePublic(dtoObject: Pick<CmsTopicSubscriptionPublicRequest, "deviceToken" | "topicHdrGuid">, websiteCode: string, apiVisa: ApiVisa) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;

    const queryParams = `?topicHdrGuid=${dtoObject.topicHdrGuid}&deviceToken=${dtoObject.deviceToken}`;

    const path = domain + this.endpoint_path + '/unsubscribe/login-ep' + queryParams;

    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code,
        websiteCode: websiteCode
      })
    };

    return this.httpClient.delete<ApiResponseModel<TopicSubscriptionContainerModel>>(
      path,
      httpOptions
    );
  }

  getTopicSubscriptionsForDevice(pagination: Pagination, apiVisa: ApiVisa, deviceToken?: string) {
    const domain = (apiVisa.api_domain_url == null || apiVisa.api_domain_url == '') ?
      Core2Config.DOMAIN_URL :
      apiVisa.api_domain_url;

    const path = this.endpoint_path + '/public-ep/user-subscriptions';

    const httpOptions: { headers: HttpHeaders } = {
      ...this.getHttpHeader(apiVisa),
    };

    const UrlByCriteria = domain + path + (deviceToken == null ? '?' : `?deviceToken=${deviceToken}`) + pagination.getQueryKeyValues();

    return this.httpClient.get<PagingResponseModel<TopicSubscriptionContainerModel>>(
      UrlByCriteria,
      httpOptions
    );
  }
}
